import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isSameDay, parseISO } from "date-fns";
import { useEffect, useState } from 'react';
import { Search, Filter, ListOrdered, Download, RotateCcw, Printer, ClipboardList } from 'lucide-react';
import { Lpp2Item, LppItem, Status2Filter} from "../../../../model/Hublang";
import { fetchPetugasAvailable, fetchPatchVerif} from '../../../../controller/dashboard/Loket';
import { fetchLppListBukaDataGet, fetchLppListWPetugas } from "../../../../controller/dashboard/Cekmeter";
import { SquareCheckBig } from "lucide-react";
import { fetchGetLPPAChoosed, fetchGetLPPANow } from "../../../../controller/dashboard/Loket2";

export default function Lpp(){
    const [petugas, setPetugas] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [loadingPreviewBackend, setLoadingPreviewBackend] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [dphaKode, setDphaKode] = useState<string>('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default
    const [petugasList, setPetugasList] = useState<any[] >([]);
    const [tanggalFilter, setTanggalFilter] = useState<Date | null>(null);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [selectedIndexPetugas, setSelectedIndexPetugas] = useState<number | null>(null);
    const [statusFilter, setStatusFilter] = useState({
        TGL_BYR : 'all',
        NAMA : 'all',
        person : 'all',
    });
    const [statusLength, setStatusLength] = useState('10');
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [lppData, setLppData] = useState<Lpp2Item[]>([]);
    const dphaKodeTanggal = (date : Date | null) => {
        if (date) {
            const year = date.getFullYear().toString().slice(-2); // Ambil 2 angka terakhir (26)
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Bulan (01-12)
            const day = date.getDate().toString().padStart(2, '0'); // Tanggal (01-31)

            const formattedDate = `${year}${month}${day}`;

            return formattedDate; // Hasilnya: "260130"
            // setTanggalFilter(date); // Tetap simpan objek Date asli untuk state DatePicker
        } else {
            console.log(null);
        }
    } 


    const filteredLpps = lppData.filter(lpp => {
        // const matchesSearch =lpp.person.toLowerCase().includes(searchTerm.toLowerCase()) 

            // const matchesTanggal = !statusFilter.TGL_BYR || isSameDay(new Date(lpp.TGL_BYR), statusFilter.TGL_BYR);

        const matchesStatus = (statusFilter.person === 'all' || lpp.person === statusFilter.person)

        return matchesStatus;
    }).sort((a, b) => {
        return a.NOSAMW.localeCompare(b.NOSAMW)
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentLpps = filteredLpps.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredLpps.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const handlePickPetugasFromList = (petugas : string ) => {
        setPetugas(petugas);
        setStatusFilter({ ...statusFilter, person : petugas})
    }

    const handleDPHAData = async (dpha : string) => {
        setPetugas('');
        const response = await fetchGetLPPAChoosed(dpha);
        const data = response.data;
        // console.log(data);
        const person = Array.from(new Set(data.map((item : any) => item.person)));
        setPetugasList(person);
        setLppData(data);
        setPetugas('all');
    } 
    

    useEffect(() => {
        setItemsPerPage(Number(statusLength === 'all' ? lppData.length : statusLength))
    }, []);

    return(
        <>
            <div>
                <div className="bg-white rounded-xl shadow-lg p-2 mb-6">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                        <div className="w-full md:w-72 flex flex-col space-y-4" style={{ width: '10rem' }}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal bayar (sort)</label>
                                <DatePicker
                                    selected={tanggalFilter}
                                    onChange={(date: Date | null) => {
                                        setTanggalFilter(date)
                                        setSelectedDate(date);
                                        handleDPHAData(`/dpha/${dphaKodeTanggal(date)}`);
                                        
                                    }}
                                    placeholderText="Pilih tanggal bayar"
                                    dateFormat="dd-MM-yyyy"
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                    isClearable
                                />
                            </div>
                            <div>
                                <div className="flex flex-col space-y-2 max-h-64 overflow-y-auto pr-2">
                                    {loading ? (
                                        <div className="text-sm text-gray-500">Loading...</div>
                                    ) : petugasList.length > 0 ? (
                                        <>
                                        <button
                                            onClick={() => handlePickPetugasFromList('all')}
                                            className={`text-left w-full rounded-md px-3 py-2 border transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 bg-sky-50 border-sky-300`}
                                        >
                                            <div className="text-sm font-medium">Semua Petugas</div>
                                        </button>
                                        {petugasList.map((item, idx) => {
                                            return (
                                            <button
                                                key={String(idx)}
                                                onClick={() => handlePickPetugasFromList(item)}
                                                className={`text-left w-full rounded-md px-3 py-2 border transition-shadow hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 ${
                                                selectedIndexPetugas === idx
                                                    ? "bg-sky-50 border-sky-300"
                                                    : "bg-white border-gray-200"
                                                }`}
                                                aria-pressed={selectedIndexPetugas === idx}
                                            >
                                                <div className="text-sm font-medium">{item}</div>
                                            </button>
                                            );
                                        })}
                                        </>
                                    ) : (
                                        <div className="text-sm text-gray-500">Tidak ada data</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="flex-1 min-w-0 overflow-auto">
                            {
                                !loading && petugas != "" ? (<DetailPreviemLppListModal Petugas={petugas} lppData={filteredLpps}/>)
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div> 
         </>
    )
}

export const DetailPreviewLppTableModal = ({ filteredLppDetail } : { filteredLppDetail : Lpp2Item[] | any }) => (
    <div className="max-h-97 overflow-visible">
        <div className="overflow-x-auto max-w-full">
            <table className="min-w-full table-auto border border-gray-400 text-sm">
            <thead className="bg-gray-100">
                <tr>
                    <th className="border px-1 py-4 text-center">No</th>
                    <th className="border px-1 py-4 text-center">Petugas Loket</th>
                    <th className="border px-2 py-4 text-center">Tanggal Bayar</th>
                    <th className="border px-2 py-4 text-center">No. Sambung</th>
                    <th className="border px-1 py-4 text-center">Nama</th>
                    <th className="border px-2 py-4 text-center">Alamat</th>
                    <th className="border px-2 py-4 text-center">KLAS</th>
                    <th className="border px-2 py-4 text-center">Ms. Tag.</th>
                    <th className="border px-2 py-4 text-center">Jumlah</th>
                    <th className="border px-2 py-4 text-center">Air. PM. Lim. Adm</th>
                    <th className="border px-2 py-4 text-center">Jml. NA</th>
                    <th className="border px-2 py-4 text-center">Dnd. Met. BT</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
            { filteredLppDetail && filteredLppDetail.length > 0 ? (
                <>
                    { filteredLppDetail && filteredLppDetail.length > 0 ? (
                        <tr className="font-bold bg-yellow-100">
                            <th colSpan={13} className="border px-2 py-4 text-center">
                                LLP-A
                            </th>
                        </tr>
                    ) : ''}

                    {filteredLppDetail.map((lpp: any, idx: number) => (
                        <tr key={lpp.no} className="hover:bg-gray-50 transition-colors">
                            <td className="border px-1 py-4 text-center">{idx + 1}</td>
                            <td className="border px-1 py-4 text-center">{lpp.person}</td>
                            {/* <td className="border px-2 py-4 text-center">{lpp.TGL_BYR}</td> */}
                            <td className="border px-2 py-4 text-center">{lpp.TGL_BYR.split('T')[0].split('-').reverse().join('-')}</td>
                            <td className="border px-2 py-4 text-center">{lpp.NOSAMW}</td>
                            <td className="border px-1 py-4 text center">{lpp.NAMA}</td>
                            <td className="border px-2 py-4 text-center">{lpp.ALAMAT}</td>
                            <td className="border px-2 py-4 text-center">{lpp.JLW}</td>
                            <td className="border px-2 py-4 text-center">{lpp.PERIODE}</td>
                            <td className="border px-2 py-4 text-center">{(parseInt(lpp.HAIR) + parseInt(lpp.DENDA)).toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                            <td className="border px-2 py-4 text-center">{parseInt(lpp.HAIR).toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                            <td className="border px-2 py-4 text-center"> - </td>
                            <td className="border px-2 py-4 text-center">{parseInt(lpp.DENDA).toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                        </tr>
                    ))}

                    <tr className="font-bold bg-blue-100">
                        <td colSpan={7} className="border px-3 py-2 text-center">TOTAL</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.HAIR) + Number(t.DENDA) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.HAIR) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td colSpan={3} className="border px-3 py-2 text-center"></td>
                    </tr>

                    <tr className="font-bold bg-yellow-100">
                        <th colSpan={13} className="border px-3 py-2 text-center">
                            LPP-A TRANSFER
                        </th>
                    </tr>

                    <tr className="font-bold bg-blue-100">
                        <td colSpan={7} className="border px-3 py-2 text-center">TOTAL</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.HAIR) + Number(t.DENDA) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.HAIR) || 0), 0).toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })}</td>
                        <td colSpan={3} className="border px-3 py-2 text-center"></td>
                    </tr>
                </>
                    ) : (
                    <tr>
                        <td colSpan={13} className="text-center py-4 text-gray-500">
                        Tidak ada data
                        </td>
                    </tr>
                    )
                }
                
            </tbody>
            </table>
        </div>
    </div>
)

export const DetailPreviemLppListModal = ({ Petugas, lppData } : { Petugas : string; lppData : Lpp2Item[] } ) => {
    const [tanggalFilter, setTanggalFilter] = useState<Date | null>(null);
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [filteredLppDetail, setFilteredLppDetail] = useState<any[]>([]);
    const [tanggalList, setTanggalList] = useState<any[] >([]);
    const [loading, setLoading] = useState(false);
    const [tableState, setTableState] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const [tableLppId, setTableLppId] = useState<any>({});
    const [manajerHublang, setManajerHublang] = useState<string>('');
    const [asmenPenagihan, setAsmenPenagihan] = useState<string>('');
    const [asmenKas, setAsmenKas] = useState<string>('');
    const [petugasLoket, setPetugasLoket] = useState<string>('');

    const load = async (mounted : boolean) => {
        setLoading(true);
        try {
          const resp = await fetchLppListWPetugas(Petugas);
          if (!mounted) return;
          // contoh: resp bisa berupa array atau { data: [...] }
          const arr = Array.isArray(resp) ? resp : (resp?.data && Array.isArray(resp.data) ? resp.data : []);
          setTanggalList(arr);
        } catch (err: any) {
          if (!mounted) return;
          setError(String(err?.message ?? err));
        } finally {
          if (!mounted) return;
          setPetugasLoket(Petugas);
          setLoading(false);
        }
    };    

    useEffect(() => {
        let mounted = true;
        load(mounted);
        return () => { mounted = false; };
    }, [Petugas]);

    return (
        
        <div>
            <div className="p-3">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                        <div className="text-sm text-gray-500 mb-2"> Buka data <br />{ petugasLoket ? <>( {petugasLoket} )</> : '' } : </div>
                        <button 
                        // onClick={() => setMenuStatus("lpp")}
                        className={`flex items-center px-4 py-2 text-gray-700 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors`}>
                            <Download className="w-4 h-4 mr-2" />
                            Export Xlsx
                        </button>
                    </div>
                </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-3 mb-6">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                    <div className="flex-1 min-w-0 overflow-auto">
                        { tableState ? 
                            <DetailPreviewLppTableModal filteredLppDetail={lppData} />
                            :
                            <div>
                                Tekan Lagi !
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};